import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { UiNotificationComponent } from "./ui-notification.component";
import { FailureNotificationComponent } from "./failure-notification.component";
import { SuccessNotificationComponent } from "./success-notification.component";
import { UpdateNotificationComponent } from "./update-notification.component";
import { FeatureUpgradeNotificationComponent } from "./feature-upgrade-notification.component";
import { CustomOverlayComponent } from "./custom-overlay.component";
import { UpgradeModalComponent } from "./upgrade-modal.component";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@NgModule({
  declarations: [
    UiNotificationComponent,
    FailureNotificationComponent,
    SuccessNotificationComponent,
    UpdateNotificationComponent,
    FeatureUpgradeNotificationComponent,
    CustomOverlayComponent,
    UpgradeModalComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    UiNotificationComponent,
    FailureNotificationComponent,
    SuccessNotificationComponent,
    UpdateNotificationComponent,
    FeatureUpgradeNotificationComponent,
    CustomOverlayComponent,
    UpgradeModalComponent,
  ],
})
export class UiNotificationModule {}
